import {
  AGREE,
  REQUEST_EXAM_DATA,
  CHANGE_EXAM,
  APPROVE_EXAM,
  UPDATE_APPEAL_DATA,
  TOGGLE_EXAM_SHOW_ONLY_INCORRECT
} from '../constants';
import { sendStats, STEP_COMPLETE } from '../../resources/metrics';

export const getExamData = payload => {
  sendStats(STEP_COMPLETE('Данные участника ГИА'));
  return { type: REQUEST_EXAM_DATA, payload };
};

export const updateAppealData = payload => ({
  type: UPDATE_APPEAL_DATA,
  payload
});

export const toggleExamShowOnlyIncorrect = payload => ({
  type: TOGGLE_EXAM_SHOW_ONLY_INCORRECT,
  payload
});

export const agree = event => ({ type: AGREE, payload: event.target.checked });

export function changeExam(payload) {
  return dispatch => {
    dispatch({ type: CHANGE_EXAM, payload });
  };
}

export function approveExam(payload) {
  return dispatch => {
    dispatch({ type: APPROVE_EXAM, payload });
  };
}
